import { graphql } from 'react-relay';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { isUnauthorizedError } from '@confluence/error-boundary/entry-points/isUnauthorizedError.ts';
import { isNotFoundError } from '@confluence/error-boundary/entry-points/isNotFoundError.ts';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import type { useCompanyHubPremiumGateCompanyHubPremiumGateQuery as useCompanyHubPremiumGateCompanyHubPremiumGateQuery$data } from './__types__/useCompanyHubPremiumGateCompanyHubPremiumGateQuery.ts';
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
export const useCompanyHubPremiumGate = ({
	skip = false,
}: {
	skip?: boolean | undefined;
} = {}): boolean => {
	const { edition } = useSessionData();

	const shouldSkip = skip || edition === ConfluenceEdition.PREMIUM;
	const { data, error } = useQueryInterop<useCompanyHubPremiumGateCompanyHubPremiumGateQuery$data>(
		graphql`
			query useCompanyHubPremiumGateCompanyHubPremiumGateQuery {
				entitlements {
					companyHub {
						isEntitled
					}
				}
			}
		`,
		{
			skip: shouldSkip,
		},
	);

	if (error) {
		if (!(isUnauthorizedError(error) || isNotFoundError(error))) {
			getMonitoringClient().submitError(error, {
				attribution: Attribution.MIGRATIONS_TOOLING,
			});
		}
		markErrorAsHandled(error);
	}

	return !shouldSkip && !data?.entitlements?.companyHub?.isEntitled;
};
